function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e51;}.cls-3{fill:#b40;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25,6.42V5.13h1.5a.46.46,0,0,0,.48-.5V2.23H28.4v2.9h3.08V6.42H28.4V12.1c0,1.13.43,1.71,1.56,1.71h1.39v1.32H29.87a2.7,2.7,0,0,1-3-3V6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.29,6.38A5.07,5.07,0,0,1,38,4.88a5,5,0,0,1,3.73,1.5,5.15,5.15,0,0,1,1.48,3.75,5.22,5.22,0,1,1-10.44,0A5.09,5.09,0,0,1,34.29,6.38Zm1.08,6.54A3.53,3.53,0,0,0,38,14a3.57,3.57,0,0,0,2.64-1.08,3.88,3.88,0,0,0,1-2.79,3.86,3.86,0,0,0-1-2.76A3.47,3.47,0,0,0,38,6.27a3.41,3.41,0,0,0-2.63,1.11,3.92,3.92,0,0,0-1,2.75A3.91,3.91,0,0,0,35.37,12.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M44.87,15.13V.71h1.52V9.85h.11l4.29-4.72h1.92L49.08,9,53,15.13H51.23l-3.17-5-1.67,1.79v3.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M65.33,15.13v-10h1.52V6.6H67A3.26,3.26,0,0,1,70,4.88,3.46,3.46,0,0,1,72.73,6a4,4,0,0,1,1,2.83v6.28H72.23V8.94A2.51,2.51,0,0,0,71.48,7a2.55,2.55,0,0,0-1.82-.73,2.68,2.68,0,0,0-2,.82,2.77,2.77,0,0,0-.81,2v6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M63.34,9.33c0,.22,0,.44,0,.67v.67H53.64m0,0a4.7,4.7,0,0,1,0-.54,5.29,5.29,0,0,1,.05-.8h9.67"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M75.06,5.54v-.4h1.79v.4h-.68V7.75h-.43V5.54Zm2.21,2.21V5.14h.43l1,2.05h0l1-2.05h.43V7.75h-.42V6h0l-.8,1.71h-.35L77.71,6h0V7.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,15a5,5,0,1,1,5-5A5,5,0,0,1,10,15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M10,15a5,5,0,1,1,5-5,6.25,6.25,0,1,0-6.25,6.25A6.25,6.25,0,0,0,15,10,5,5,0,0,1,10,15Z"
})));

function SvgTokNLogoS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80.1 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokNLogoS);
export default __webpack_public_path__ + "static/media/tok-n-logo-s.154de666.svg";
export { ForwardRef as ReactComponent };